// TemplatesList.jsx — proc-v3 (F2.3g): NONA VISTA DEL MONOLITE in React,
// "Libreria modelli" (templates), flag-gated (shell_proc_v3_templates,
// default OFF). SECONDA vista sul componente condiviso CardGrid: nel v1 è
// una card-grid per GRUPPI collassabili (grid-cols-1 md:grid-cols-2).
//
// Replica 1:1 renderTemplates di proc-v0.js:10323-10367: stesso titolo/
// ricerca/bottone (hardcoded IT — TPL_TEXTS VERBATIM in api.js), stessi
// gruppi (sentinella '— Senza gruppo —' SEMPRE ultima, localeCompare sugli
// altri), stesso filtro substring su nome/oggetto/corpo/gruppo, stesse card
// (nome + badge kind·lingua·canale + oggetto + corpo in <pre>), stesso click
// card → openTemplateModal DEL MONOLITE (MODALE: il v3 resta montato sotto,
// come Conversazioni).
//
// STATO DI VISTA (parità v1): templateSearch/templateCollapsed nel v1 sono
// binding LESSICALI di modulo (v1:10324-10325) — sopravvivono alla
// navigazione tra viste e muoiono al reload. Qui vivono nella CLOSURE della
// factory (viewState) e si passano al componente: unmount/remount non li
// azzera, il reload sì. STESSO ciclo di vita.
//
// CONFINI (pattern f23c): modale template = V1 (delega in api.js);
// MAI 'nav:badge' da questo modulo.

import React from 'react';
import { CardGrid } from '../ui/CardGrid.jsx';
import {
  TPL_TEXTS, readTemplates, tplBadgeText,
  tplOpenNew, tplOpenDetail,
} from './api.js';

// Contenuto card (_tplCard v1:10329-10335) — il CHROME lo mette CardGrid.
// NB PARITÀ TESTUALE (bug 2 di f23f): il template literal v1 lascia
// NODI-SPAZIO tra header/oggetto/corpo — i {' '} li replicano (in blocco
// normale un nodo di solo whitespace non si vede: parità solo testuale).
function TemplateCard({ t }) {
  return (
    <>
      <div className="flex justify-between items-center mb-2">
        <div className="font-bold">{t.name}</div>
        <span className="bg-slate-100 text-slate-700 text-[10px] px-1.5 py-0.5 rounded">{tplBadgeText(t)}</span>
      </div>
      {' '}
      {t.subject ? <>{ /* v1: divs adiacenti separati dal nodo-spazio */ }<div className="text-xs text-slate-500 mb-1">{t.subject}</div>{' '}</> : null}
      <pre className="bg-slate-50 border rounded p-2 text-xs whitespace-pre-wrap text-slate-700">{t.body || ''}</pre>
    </>
  );
}

export function TemplatesList({ win, tick, viewState }) {
  // ricerca: React state per il repaint, closure per la persistenza (parità
  // col binding lessicale templateSearch del v1)
  const [search, setSearchState] = React.useState(viewState.search || '');
  const [, setRev] = React.useState(0); // i collassi vivono nel Set esterno: qui solo il repaint
  const setSearch = (v) => { viewState.search = v; setSearchState(v); };
  const toggleGroup = (g) => {
    if (viewState.collapsed.has(g)) viewState.collapsed.delete(g);
    else viewState.collapsed.add(g);
    setRev((n) => n + 1);
  };

  // dati: letti dallo store del monolite a ogni refresh (tick dal wrapper) —
  // stessa composizione del v1 (api.readTemplates)
  const sections = React.useMemo(() => readTemplates(win, search), [win, tick, search]);

  return (
    <div>
      <div className="flex justify-between items-center mb-3 gap-2 flex-wrap">
        <h1 className="text-2xl font-bold">{TPL_TEXTS.title}</h1>
        <div className="flex gap-2">
          <input
            id="tpl-search"
            className="border rounded px-3 py-1.5 text-sm"
            placeholder={TPL_TEXTS.searchPlaceholder}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            id="btn-new-template"
            type="button"
            className="bg-cyan-600 hover:bg-cyan-700 text-white px-4 py-1.5 rounded text-sm whitespace-nowrap"
            onClick={() => tplOpenNew(win)}
          >{TPL_TEXTS.newBtn}</button>
        </div>
      </div>

      {sections.length ? sections.map((sec) => {
        const collapsed = viewState.collapsed.has(sec.name);
        return (
          <div className="mb-4" key={sec.name}>
            <button
              type="button"
              className="tpl-grp-h w-full flex items-center justify-between text-left mb-2 px-1"
              onClick={() => toggleGroup(sec.name)}
            >
              <span className="font-semibold text-slate-800">
                {sec.isNoGroup ? <span className="text-slate-400 italic">{TPL_TEXTS.noGroupLabel}</span> : sec.name}
                {' '}
                <span className="text-xs text-slate-400 font-normal">({sec.items.length})</span>
              </span>
              {' ' /* nodo-spazio del v1 tra i due span dell'header */}
              <span className="text-slate-400 text-xs">{collapsed ? TPL_TEXTS.collapsedToggle : TPL_TEXTS.expandedToggle}</span>
            </button>
            {collapsed ? null : (
              <CardGrid
                items={sec.items}
                itemKey="id"
                twoColAt="md"
                onCardClick={(t) => tplOpenDetail(win, t.id)}
                renderCard={(t) => <TemplateCard t={t} />}
                emptyMessage={TPL_TEXTS.emptyMessage}
              />
            )}
          </div>
        );
      }) : (
        // store vuoto O ricerca che esclude tutto: stato VUOTO del design
        // system con il testo v1 (il testo digitato resta nell'input)
        <CardGrid items={[]} itemKey="id" renderCard={() => null} emptyMessage={TPL_TEXTS.emptyMessage} />
      )}
    </div>
  );
}

// Factory (pattern createProcV3Tags) con STATO DI VISTA nella closure:
// search/collapsed sopravvivono a unmount/remount (navigazione) e muoiono al
// reload — stesso ciclo di vita dei binding lessicali del v1.
export function createProcV3Templates(win) {
  let root = null;
  let mountedEl = null;
  let tick = 0;
  const viewState = { search: '', collapsed: new Set() };

  function render() {
    const container = win.document.getElementById('templates-content');
    if (!container) throw new Error('#templates-content assente');
    if (!root || mountedEl !== container || !container.isConnected) {
      if (root) { try { root.unmount(); } catch (e) { /* già smontato */ } }
      container.replaceChildren(); // eventuali resti del v1 (catch-up)
      root = win.ReactDOM.createRoot(container);
      mountedEl = container;
    }
    tick += 1; // ogni chiamata del wrapper = refresh dati (rerenderAll dal modale, rientro)
    root.render(<TemplatesList win={win} tick={tick} viewState={viewState} />);
  }

  function unmount() {
    if (root) {
      try { root.unmount(); } catch (e) { /* già smontato */ }
      root = null;
    }
    mountedEl = null;
  }

  function isMounted() { return !!root; }

  return { render, unmount, isMounted };
}
